import { setSearchTermAction, turnOnLoaderSearchAction } from './store'
import { connect } from 'react-redux'
import UI from './UI'

const mapStateToProps = ({ topic }) => ({
  searchLoader: topic.searchLoader
})

const mapDispatchToProps = dispatch => ({
  setSearchTerm: (searchTerm) => dispatch(setSearchTermAction(searchTerm)),
  turnOnLoaderSearch: () => dispatch(turnOnLoaderSearchAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
